import { render, staticRenderFns } from "./sending-airtime-to-zimbabwe.vue?vue&type=template&id=e579be22"
import script from "./sending-airtime-to-zimbabwe.vue?vue&type=script&lang=js"
export * from "./sending-airtime-to-zimbabwe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports